/* eslint-disable react/no-render-return-value */
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './react/index';

/** The master component render outlet */
export const FHWSearchOutlet = (element: HTMLElement): void => {
	const root = createRoot(element!);
	root.render(<App />);
};
